import ExpandedView from "src/components/ExpandedView";
import PatientDisputes from "src/components/PatientDisputes";
import { usePatient } from "src/context/PatientProvider";

const Disputes = () => {
  const patient = usePatient((p) => p);

  return (
    <ExpandedView>
      <PatientDisputes patient={patient} />
    </ExpandedView>
  );
};

export default Disputes;
